import { Component, effect, input, output, Type, untracked } from '@angular/core';
import { Building05 } from '../../icons/building-05/building-05';
import { UserCircle } from '../../icons/user-circle/user-circle';
import { FormsModule } from '@angular/forms';
import { Select } from 'primeng/select';
import { ChevronRight } from '../../icons/chevron-right/chevron-right';
import { DynamicIconComponent } from '../../ui/dynamic-icon/dynamic-icon';

@Component({
  standalone: true,
  selector: 'app-client-type-dropdown',
  imports: [Select, FormsModule, DynamicIconComponent, ChevronRight],
  templateUrl: './client-type-dropdown.html',
  styleUrl: './client-type-dropdown.scss',
})
export class ClientTypeDropdown {
  options: { icon: Type<any>; label: string; value: boolean }[];
  reset = input(0);
  selectedOption: { icon: Type<any>; label: string; value: boolean } | undefined;

  dropdownStyle = {
    colorScheme: {
      light: {
        root: {
          background: 'transparent',
          filledHoverBackground: '#F7F8FA',
          filledFocusBackground: '#F7F8FA',
          color: '#181D27',
          borderColor: 'transparent',
          focusBorderColor: 'transparent',
          filledFocusBorderColor: 'transparent',
          hoverBorderColor: 'transparent',
          shadow: 'none',
        },
      },
    },
  };

  onSelect = output<boolean | undefined>();

  constructor() {
    this.options = [
      {
        label: 'Pravna lica',
        icon: Building05,
        value: true,
      },
      {
        label: 'Fizička lica',
        icon: UserCircle,
        value: false,
      },
    ];

    effect(() => {
      this.reset();
      untracked(() => this.selectedOption = undefined);
    });
  }
}
